/**
 * 接口文档
 * http://api-doc-sl.inshopline.com/#/project/92/feature%2F20211013_v1.0.0/interface/b673d5ec4a9ed2e64e501ffa059aeb39
 */
export default {
  /** 查询该邮箱是否禁用 */
  checkEmailAuth: '/api/users/banned-query',
  /**获取个人信息 */
  getUerInfo: '/api/users/get',
  /**店铺绑定 */
  bind: '/api/stores/bind',
  /**店铺解绑 */
  unbind: '/api/stores/unbind',
  /**查询店铺绑定列表 */
  bindStoreList: '/api/stores/list',
  /**查询是否已经被绑定 */
  checkBind: '/api/stores/bind/check',
  /**重新获取店铺信息 */
  refreshStoreInfo: '/api/stores/refresh-info',

  updateInfo: '/api/users/update',
  /** 确认申诉(个人) */
  userAppealConfirm: '/oneclub-api/api/appeal/confirm',
  /** 更新店铺信息 */
  updateStoreInfo: '/api/stores/update',
  /** 商家注销 */
  sellerCancel: '/api/settings/cancel',
  /** 商家注销（邮箱确认） */
  sellerCancelConfirm: '/api/settings/cancel-confirm',
  /** 商家邮件预校验 */
  checkEmail: '/api/settings/check-email',
  /** 更新用户信息里面的 notification_emails 字段，不影响 user_info  */
  updateNotificationEmail: '/api/users/update-notify-email',
  /** 获取授权url(虾皮等) */
  getStoreAuthorizeUrl: '/api/stores/get-url',
  /** 未登陆时获取授权url(虾皮等) */
  getStoreAuthorizeUrlWithoutLogin: '/api/stores/get-url/skip',
  /** 店铺绑定 */
  bindStoresUrl: '/api/stores/bind',

  /** 支持库存地点的平台配置 */
  supportLocationPlatform: '/api/store/location/platform',
  /** 查询地址列表  */
  queryLocationList: '/api/store/location/list',

  /**
   * 店铺地点校验
   */
  checkLocation: '/api/store/location/check',

  /**
   * 店铺库存地点设置
   */
  setStockLocation: '/api/store/location/set',

  /**
   * 店铺库存地点置空
   */
  clearStockLocation: '/api/store/location/noneSet',

  /** 获取权限树 */
  authTree: '/api/users/resource-tree',

  storeStockLocationDetail: '/api/store/location/detail',
}
